import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { VerifyMagicLink } from '@simplybenefits/sb-ui-library';
import { verifyToken } from '../../actions/advisor.js';

/**
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
const AdvisorVerifyMagicLink = (props) => {
    const location = useLocation();

    return (
        <VerifyMagicLink
            location={ location }
            verifyToken={ (...params) => props.dispatch(verifyToken(...params)) }
            whitelabel={ props.whitelabel }
            isLoading={ props.loader.isLoading }
        />
    );
};

/**
 *
 * @param state
 * @returns {{whitelabel}}
 */
const mapStateToProps = (state) => ({
    whitelabel: state.whitelabel,
    loader: state.loader
});

export default connect(mapStateToProps)(AdvisorVerifyMagicLink);